import languagesReducer, { LanguagesAction } from './reducer';
import languagesEpic from './epic';
import { ILanguageData } from './models';
import * as languagesActions from './actions';

export { languagesEpic, ILanguageData, LanguagesAction, languagesActions };
export default languagesReducer;



// WEBPACK FOOTER //
// ./src/store/modules/languages/index.ts